import { jsx as h } from "react/jsx-runtime";
import { c as s } from "./index-65016bfa.mjs";
import c, { css as l } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as v } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
var t = /* @__PURE__ */ ((r) => (r.HORIZONTAL = "horizontal", r.VERTICAL = "vertical", r))(t || {}), e = /* @__PURE__ */ ((r) => (r.Thin = "1px", r.Thick = "2px", r.Thicker = "3px", r))(e || {});
const d = c.div`
  &.Divider {
    ${({ $thickness: r, $size: i, $margin: o }) => `
      margin: ${o};
      &--horizontal {
        max-height: ${r};
        height: ${r};
        width: ${i};
      },

      &--vertical {
        height: ${i};
        width: ${r};
      }
  `};

    ${({
  theme: {
    components: { divider: r }
  }
}) => l(r.Divider)};
  }
`, N = ({
  layout: r = t.HORIZONTAL,
  style: i,
  thickness: o = e.Thin,
  size: m = "100%",
  margin: a,
  className: p
}) => {
  const n = v({ label: "Divider" });
  return /* @__PURE__ */ h(
    d,
    {
      style: i,
      $thickness: o,
      $size: m,
      $margin: a,
      className: s(
        "Divider",
        {
          "Divider--vertical": t.VERTICAL === r,
          "Divider--horizontal": t.HORIZONTAL === r
        },
        p
      ),
      ...n
    }
  );
};
export {
  N as Divider,
  t as DividerLayout,
  e as DividerThickness
};
